<script>
	export let type;
</script>

<span class="badge bg-primary rounded-pill">
	<slot></slot>
</span>
